export default "__VITE_ASSET__sGHIPQYd__"